var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{key:"new",staticClass:"flex-1",attrs:{"src":_vm.pdf_view_url,"width":"100%","height":"100%","id":"pdfIfram"},on:{"load":_vm.iframeLoaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }